import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ml-auto pt-3 pb-1 px-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "px-2" }
const _hoisted_4 = {
  key: 0,
  class: "px-2"
}
const _hoisted_5 = {
  key: 1,
  class: "px-2"
}
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = { class: "px-2" }
const _hoisted_8 = { class: "ml-auto pt-3 pb-1 px-2" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_AuditCheckCard = _resolveComponent("AuditCheckCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AccountingClientMonitoringProductionRow = _resolveComponent("AccountingClientMonitoringProductionRow")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_AccountingClientMonitoringTaxesRow = _resolveComponent("AccountingClientMonitoringTaxesRow")!
  const _component_AccountingClientMonitoringClosureRow = _resolveComponent("AccountingClientMonitoringClosureRow")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_CompanyConnectors = _resolveComponent("CompanyConnectors")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ChatCompany = _resolveComponent("ChatCompany")!
  const _component_AuditCheckDocumentDialog = _resolveComponent("AuditCheckDocumentDialog")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pa-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "py-1 px-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "pa-1",
            cols: "12"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("h3", null, "Production", -1)
            ])),
            _: 1
          }),
          (_ctx.isAuditCheckDocumentAnomalyCardVisible || _ctx.loadingAuditCheckDocuments)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.openPointCardColSize,
                class: "px-1 py-1"
              }, {
                default: _withCtx(() => [
                  (_ctx.loadingAuditCheckDocuments)
                    ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 0,
                        class: "mx-auto",
                        type: "list-item"
                      }))
                    : (_openBlock(), _createBlock(_component_AuditCheckCard, {
                        key: 1,
                        auditCheckItemsCount: _ctx.auditCheckDocumentsWithAnomalyCount,
                        hasBorder: true,
                        onClick: _ctx.onAuditCheckDocumentAnomalyCardClicked,
                        class: "cursor-pointer border-sm fill-height"
                      }, null, 8, ["auditCheckItemsCount", "onClick"]))
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.openPointCardColSize,
            class: "px-1 py-1"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingOpenPoints)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    class: "mx-auto",
                    type: "list-item"
                  }))
                : (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "pa-3 fill-height border-sm bg-white rounded-xl",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showWaitingBT()))
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.accountingPeriodId)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            class: "mx-auto text-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.noAccountingPeriodMessage), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex align-center justify-center",
                              style: {"border-right":"1px #ededed solid"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: 
                                    _ctx.openPoints.waitingAccount.accountingTransactions.length
                                        ? 'red'
                                        : 'green'
                                
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.openPoints.waitingAccount.accountingTransactions.length
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "10",
                              class: "d-flex align-center pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                                    "openPoints.waitingAccount",
                                    _ctx.openPoints.waitingAccount.accountingTransactions.length,
                                    {
                                        count: _ctx.openPoints.waitingAccount.accountingTransactions
                                            .length,
                                    },
                                )), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, {
            cols: _ctx.openPointCardColSize,
            class: "px-1 py-1"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingOpenPoints)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    class: "mx-auto",
                    type: "list-item"
                  }))
                : (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "pa-3 fill-height border-sm bg-white rounded-xl",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showItems(_ctx.openPoints.document.pendingValidation)))
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.accountingPeriodId)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            class: "mx-auto text-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.noAccountingPeriodMessage), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex align-center justify-center",
                              style: {"border-right":"1px #ededed solid"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: 
                                    _ctx.openPoints.document.pendingValidation.count ? 'red' : 'green'
                                
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.openPoints.document.pendingValidation.count
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "10",
                              class: "d-flex align-center pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                                    "openPoints.toValidateDocuments",
                                    _ctx.openPoints.document.pendingValidation.count,
                                    { count: _ctx.openPoints.document.pendingValidation.count },
                                )), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, {
            cols: _ctx.openPointCardColSize,
            class: "px-1 py-1"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingOpenPoints)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    class: "mx-auto",
                    type: "list-item"
                  }))
                : (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "pa-3 fill-height border-sm bg-white rounded-xl",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showItems(_ctx.openPoints.reconciliation.pendingValidation)))
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.accountingPeriodId)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            class: "mx-auto text-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.noAccountingPeriodMessage), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex align-center justify-center",
                              style: {"border-right":"1px #ededed solid"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: 
                                    _ctx.openPoints.reconciliation.pendingValidation.count
                                        ? 'red'
                                        : 'green'
                                
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.openPoints.reconciliation.pendingValidation.count
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "10",
                              class: "d-flex align-center pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                                    "openPoints.toValidateReconciliations",
                                    _ctx.openPoints.reconciliation.pendingValidation.count,
                                    { count: _ctx.openPoints.reconciliation.pendingValidation.count },
                                )), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, {
            cols: "10",
            class: "px-1 py-2"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingProduction)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    class: "py-4",
                    type: "text"
                  }))
                : (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 1,
                    headers: _ctx.productionHeaders,
                    items: [_ctx.company],
                    "fixed-header": "",
                    "hide-default-footer": "",
                    "calculate-widths": "",
                    class: "box-border rounded-xl table",
                    loading: _ctx.loadingProduction,
                    density: "compact"
                  }, {
                    item: _withCtx((props) => [
                      _createVNode(_component_AccountingClientMonitoringProductionRow, {
                        props: props,
                        headers: _ctx.productionHeaders,
                        itemValue: _ctx.productionValues,
                        taxesMonitoring: _ctx.taxesMonitoring,
                        showFECInfo: false,
                        hideName: true,
                        optionsSelected: _ctx.productionOptions,
                        rowPaddingPx: 4
                      }, null, 8, ["props", "headers", "itemValue", "taxesMonitoring", "optionsSelected"])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "py-1 px-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "pa-1",
            cols: "12"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("h3", null, "Déclarations / Clôture", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "pa-1",
            cols: "10"
          }, {
            default: _withCtx(() => [
              (_ctx.loadingTaxes)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    class: "py-4",
                    type: "text"
                  }))
                : (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 1,
                    headers: _ctx.taxesHeaders,
                    items: [_ctx.company],
                    "fixed-header": "",
                    "hide-default-footer": "",
                    "calculate-widths": "",
                    class: "box-border rounded-xl table",
                    loading: _ctx.loadingTaxes,
                    "hide-default-header": false,
                    density: "compact"
                  }, {
                    item: _withCtx((props) => [
                      _createVNode(_component_AccountingClientMonitoringTaxesRow, {
                        props: props,
                        headers: _ctx.taxesHeaders,
                        itemValue: _ctx.productionValues,
                        taxesMonitoringItem: _ctx.taxesMonitoring,
                        showFECInfo: false,
                        hideName: true,
                        taxesSelected: _ctx.taxOptions,
                        useTriangleLayout: true,
                        rowPaddingPx: 4,
                        taxType: "mixed"
                      }, null, 8, ["props", "headers", "itemValue", "taxesMonitoringItem", "taxesSelected"])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "px-0 my-1 box-border",
            style: {"background-color":"white","border-radius":"15px","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountingClientMonitoringClosureRow, {
                props: { item: _ctx.company },
                headers: _ctx.finalizationHeaders,
                auditReportMonitoring: _ctx.auditReportMonitoring,
                loading: _ctx.loadingFinalization,
                hideName: true,
                layout: 'horizontal'
              }, null, 8, ["props", "headers", "auditReportMonitoring", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "py-1 px-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "pa-1",
            cols: "12"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("h3", null, "Divers", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "px-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                outlined: "",
                style: {"border-radius":"15px"},
                height: _ctx.boxHeightInPx,
                class: "scrollbar-hidden",
                border: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "pt-3 pb-1 px-2 d-inline-block" }, "Les 10 derniers flux entrants", -1)),
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("a", _mergeProps(props, {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.routeToFilteredBanksPage && _ctx.routeToFilteredBanksPage(...args)))
                            }), [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("$fa-university")
                                ])),
                                _: 1
                              }),
                              _cache[10] || (_cache[10] = _createTextVNode(" Banques "))
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[11] || (_cache[11] = _createElementVNode("span", null, "Ouvrir la page des dernières transactions bancaires", -1))
                          ]),
                          _: 1
                        }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "px-2" }, "|", -1)),
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("a", _mergeProps(props, {
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.routeToFilteredDocumentsPage && _ctx.routeToFilteredDocumentsPage(...args)))
                            }), [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createTextVNode("$fa-receipt")
                                ])),
                                _: 1
                              }),
                              _cache[13] || (_cache[13] = _createTextVNode(" Documents "))
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Ouvrir la page des derniers documents", -1))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.loadingBankTransactions || _ctx.loadingDocuments)
                    ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 0,
                        type: "list-item@6",
                        class: "mx-2"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.incomingFlow || _ctx.incomingFlow.length === 0)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "no-gutters d-flex align-center justify-center",
                              style: {"height":"300px"}
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createElementVNode("span", { class: "my-auto" }, "Aucun flux récent", -1)
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_table, {
                              key: 1,
                              class: "scrollbar-hidden",
                              height: _ctx.flowTableHeight,
                              "fixed-header": ""
                            }, {
                              default: _withCtx(() => [
                                _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "px-2" }),
                                    _createElementVNode("th", { class: "px-2" }),
                                    _createElementVNode("th", { class: "px-2" }, "Libellé"),
                                    _createElementVNode("th", { class: "px-2" }, "Date d'ajout")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomingFlow, (flow) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      role: "button",
                                      key: flow.id,
                                      onClick: ($event: any) => (_ctx.routeToFlowPage(flow))
                                    }, [
                                      _createElementVNode("td", _hoisted_3, [
                                        (flow.flowType === 'BankTransaction')
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                _createTextVNode("$fa-university")
                                              ])),
                                              _: 1
                                            }))
                                          : (flow.flowType === 'Document')
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                  _createTextVNode("$fa-receipt")
                                                ])),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                      ]),
                                      (flow.flowType === 'BankTransaction')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(flow.docType || "-"), 1))
                                        : _createCommentVNode("", true),
                                      (flow.flowType === 'Document')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(flow.docType
                                                    ? _ctx.$t("document.type." + flow.docType)
                                                    : "-"), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", _hoisted_6, _toDisplayString(flow.label), 1),
                                      _createElementVNode("td", _hoisted_7, _toDisplayString(flow.fCreatedAt), 1)
                                    ], 8, _hoisted_2))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            }, 8, ["height"]))
                      ], 64))
                ]),
                _: 1
              }, 8, ["height"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            xs: "6",
            class: "px-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                outlined: "",
                height: _ctx.boxHeightInPx,
                style: {"border-radius":"15px"},
                class: "scrollbar-hidden",
                border: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "sticky-top bg-white"
                      }, {
                        default: _withCtx(() => [
                          _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "pt-3 pb-1 px-2 d-inline-block" }, "Connecteurs", -1)),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_add, _mergeProps({ variant: "outlined" }, props, {
                                  onClick: _ctx.routeToConnectorCreationPage,
                                  size: "small"
                                }), null, 16, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Ajouter un connecteur", -1))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.loadingConnectors || _ctx.loadingConnectedBankAccounts)
                        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                            key: 0,
                            class: "mx-2",
                            type: "card@2"
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.hasActiveConnections)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  class: "no-gutters d-flex align-center justify-center",
                                  style: _normalizeStyle({ height: `${_ctx.connectorsEmptyMsgBoxHeight}` })
                                }, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createElementVNode("span", { class: "my-auto" }, "Aucun connecteur ajouté", -1)
                                  ])),
                                  _: 1
                                }, 8, ["style"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_CompanyConnectors, {
                                    dense: true,
                                    companyId: _ctx.companyId,
                                    connectorsPerLine: 1,
                                    connectors: _ctx.activeConnectors,
                                    connectedBankAccounts: _ctx.connectedBankAccounts
                                  }, null, 8, ["companyId", "connectors", "connectedBankAccounts"])
                                ]))
                          ], 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["height"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "px-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                outlined: "",
                style: {"border-radius":"15px"},
                height: _ctx.boxHeightInPx,
                class: "scrollbar-hidden",
                border: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ChatCompany, {
                    style: {"padding":"0"},
                    height: _ctx.chatMessagesBoxHeight,
                    small: true
                  }, null, 8, ["height"])
                ]),
                _: 1
              }, 8, ["height"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_AuditCheckDocumentDialog, {
        modelValue: _ctx.shouldAuditCheckDocumentDialogBeVisible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shouldAuditCheckDocumentDialogBeVisible) = $event)),
        auditChecks: _ctx.auditCheckDocumentsWithAnomaly,
        companyId: _ctx.companyId
      }, null, 8, ["modelValue", "auditChecks", "companyId"])
    ]),
    _: 1
  }))
}